import React from "react";
import { Link, useParams } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

export default function ProviderServiceDetailPage() {
  const { serviceId } = useParams();

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>
          Service detail {serviceId ? `· ${serviceId}` : ""}
        </h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Inspect pricing, deposit policy, assigned stylists, and booking eligibility.
        </p>
      </section>

      <section style={cardStyle}>
        <div style={{ display: "grid", gap: "0.7rem", color: "#334155" }}>
          <div><strong>Service name:</strong> Demo service</div>
          <div><strong>Category:</strong> Hair</div>
          <div><strong>Price:</strong> £35.00</div>
          <div><strong>Duration:</strong> 45 minutes</div>
          <div><strong>Assigned stylists:</strong> 2</div>
          <div><strong>Deposit policy:</strong> Deposit required</div>
        </div>
      </section>

      <section style={cardStyle}>
        <Link
          to="/provider/dashboard/services"
          style={{
            textDecoration: "none",
            border: "1px solid #d1d5db",
            borderRadius: 12,
            padding: "0.75rem 1rem",
            color: "#111827",
            fontWeight: 700,
            display: "inline-flex",
          }}
        >
          Back to services
        </Link>
      </section>
    </div>
  );
}